import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {getProductSpecialCategory} from 'modules/product-card/helpers';
import {selectProductData} from 'modules/product-card/selectors';
import {useMemo} from 'react';
import {SECTION_CODE} from 'modules/product-card/constants';
import {getProductTasteCharacteristics} from 'modules/product-card/helpers/characteristics/taste';

const {AKSESSUARY, FINE_AND_RARE, MINERALNAYA_VODA, STEKLO} = SECTION_CODE;

const EXCLUDED_CATEGORIES = new Set([FINE_AND_RARE, MINERALNAYA_VODA, STEKLO, AKSESSUARY]);

const DEFAULT_RESULT = {
    isShowTaste: false,
    tasteList: [],
};

export const useTasteCharacteristics = () => {
    const productData = useAppSelector(selectProductData);

    return useMemo(() => {
        if (!productData) {
            return DEFAULT_RESULT;
        }

        const category = getProductSpecialCategory(productData);
        const shouldShowTaste = !EXCLUDED_CATEGORIES.has(category);

        if (!shouldShowTaste) {
            return DEFAULT_RESULT;
        }

        const tasteListData = getProductTasteCharacteristics(productData);

        return {
            isShowTaste: 0 < tasteListData.length,
            tasteList: tasteListData,
        };
    }, [productData]);
};
